import React, { useEffect, useRef } from 'react';
import { Picker } from 'emoji-mart';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import data from '@emoji-mart/data';

import { IconButton, Icons } from 'widget/components';
import { useWidgetContext } from 'widget/widget-context';

interface Emoji {
  native: string;
}

interface EmojiPicker {
  messageInputRef: React.RefObject<HTMLTextAreaElement>;
}

const EmojiPicker = ({ messageInputRef }: EmojiPicker) => {
  const { widget } = useWidgetContext();

  const [field, , helpers] = useField<string>('content');
  const { i18n } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  const handleEmojiSelect = ({ native }: Emoji) => {
    if (!messageInputRef.current) return;
    messageInputRef.current.focus();

    const selectionStart = messageInputRef.current.selectionStart;
    const selectionEnd = messageInputRef.current.selectionEnd;

    const text =
      field.value.substring(0, selectionStart) +
      native +
      field.value.substring(selectionEnd);

    helpers.setValue(text);
    messageInputRef.current.selectionEnd = selectionEnd + 2;
  };

  useEffect(() => {
    // eslint-disable-next-line
    const translation = require(
      `@emoji-mart/data/i18n/${i18n.resolvedLanguage}.json`,
    );

    new Picker({
      data,
      dynamicWidth: true,
      i18n: translation,
      onEmojiSelect: handleEmojiSelect,
      previewPosition: 'none',
      ref,
      theme: widget.theme,
    });
  }, [field.value]);

  return (
    <div className="whatcrm-widget-emoji-picker">
      <IconButton>
        <Icons.SmileySticker fill="gray" size={24} />
      </IconButton>

      <div className="whatcrm-widget-emoji-picker__mart" ref={ref} />
    </div>
  );
};

export default EmojiPicker;
